/* =========================================================================
   NUTROVATE homepage redesign
   Loaded by each nv-* section. Guarded so duplicate <script> tags are safe.
   Deliberately framework-free and independent of Horizon's private modules,
   so a theme update cannot break it. Cart writes go through the public
   Cart AJAX API, which is a stable contract.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__nvHomepageInit) return;
  window.__nvHomepageInit = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var CART_ADD = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  var CART_URL = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: CURRENCY
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------------- Toast ---------------- */
  var toastEl, toastTimer;
  function toast(msg, link) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4.5 4.5L19 7"/></svg>' +
      '<span></span>' + (link ? ' <a href="' + CART_URL + '">View bag</a>' : '');
    toastEl.querySelector('span').textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }

  /* ---------------- Cart ---------------- */
  // Horizon renders its own bubble markup; update it directly rather than
  // importing the theme's internals, then fire the events a theme may listen for.
  function syncCartUI(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count !== null) {
      $$('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', count === 0); });
      $$('[ref="cartBubbleCount"]').forEach(function (el) {
        el.textContent = count > 99 ? '' : String(count);
        el.classList.toggle('hidden', count === 0);
      });
    }
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart, source: 'nv-homepage' } }));
    });
  }

  function addToCart(items, label, btn) {
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.nvLabel = btn.textContent; btn.textContent = 'Adding...'; }
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to bag');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        syncCartUI(cart);
        if (!window.__nvCartDrawer) toast(label + ' added to your bag', true);
      })
      .catch(function (err) { toast(err.message || 'Something went wrong'); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); if (btn.dataset.nvLabel) btn.textContent = btn.dataset.nvLabel; }
      });
  }

  /* Reads the delivery interval out of a selling plan's name and option text,
     because Liquid does not expose the interval as a field. */
  function planMonths(txt) {
    var t = String(txt || '').toLowerCase();
    var w = t.match(/(\d+)\s*week/);
    if (w) return Math.max(1, Math.round(parseInt(w[1], 10) / 4));
    var m = t.match(/(\d+)\s*month/);
    if (m) return parseInt(m[1], 10);
    var y = t.match(/(\d+)\s*year/);
    if (y) return parseInt(y[1], 10) * 12;
    return 1;
  }

  /* =======================================================================
     Quick-add product tabs
     ======================================================================= */
  function initTabs(root) {
    var tabs = $$('.nv-qa__tab', root);
    var panels = $$('.nv-qa__panel', root);
    if (!tabs.length) return;

    /* Under 940px the panels are a scroll snapping track and all of them are
       laid out at once, so selecting means scrolling rather than toggling. */
    var track = $('.nv-qa__panels', root);
    var tabsWrap = $('.nv-qa__tabs', root);
    var mq = window.matchMedia('(max-width:939px)');
    var swipe = function () { return mq.matches && !!track; };

    /* Remember the tabpanel wiring so it can be restored above 940px. */
    var labelledBy = panels.map(function (p) { return p.getAttribute('aria-labelledby') || ''; });

    function applyRoles() {
      var on = swipe();
      if (track) {
        if (on) {
          track.setAttribute('role', 'group');
          track.setAttribute('aria-roledescription', 'carousel');
          track.setAttribute('aria-label', (tabsWrap && tabsWrap.getAttribute('aria-label')) || 'Products');
        } else {
          track.removeAttribute('role');
          track.removeAttribute('aria-roledescription');
          track.removeAttribute('aria-label');
        }
      }
      panels.forEach(function (p, i) {
        if (on) {
          p.setAttribute('role', 'group');
          p.setAttribute('aria-roledescription', 'slide');
          p.setAttribute('aria-label', (i + 1) + ' of ' + panels.length +
            (p.dataset.title ? ': ' + p.dataset.title : ''));
          p.removeAttribute('aria-labelledby');
        } else {
          p.setAttribute('role', 'tabpanel');
          if (labelledBy[i]) p.setAttribute('aria-labelledby', labelledBy[i]);
          p.removeAttribute('aria-roledescription');
          p.removeAttribute('aria-label');
        }
      });
    }

    function select(id, focus, fromScroll) {
      tabs.forEach(function (t) {
        var on = t.dataset.target === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
        /* keep the active pill in view when the tab row itself overflows */
        if (on && !fromScroll && t.scrollIntoView) {
          try { t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); }
          catch (err) { /* older Safari */ }
        }
      });
      panels.forEach(function (p) { p.classList.toggle('is-on', p.dataset.panel === id); });
      if (swipe() && !fromScroll) {
        var target = panels.filter(function (p) { return p.dataset.panel === id; })[0];
        if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }

    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (!swipe()) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          /* whichever panel centre is nearest the track centre wins */
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = null, bestD = Infinity;
          panels.forEach(function (p) {
            var c = p.offsetLeft - track.offsetLeft + p.offsetWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestD) { bestD = d; best = p; }
          });
          if (best && best.dataset.panel !== currentId()) select(best.dataset.panel, false, true);
        });
      }, { passive: true });

      mq.addEventListener('change', function () { applyRoles(); select(currentId(), false, false); });
    }

    function currentId() {
      var on = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      return on ? on.dataset.target : (tabs[0] && tabs[0].dataset.target);
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('.nv-qa__tab');
      if (t) { select(t.dataset.target); }
    });

    root.addEventListener('keydown', function (e) {
      if (!e.target.closest('.nv-qa__tab')) return;
      var map = { ArrowRight: 1, ArrowLeft: -1, Home: 'h', End: 'e' };
      if (!(e.key in map)) return;
      e.preventDefault();
      var ids = tabs.map(function (t) { return t.dataset.target; });
      var cur = ids.indexOf(e.target.dataset.target);
      var next = e.key === 'Home' ? 0 : e.key === 'End' ? ids.length - 1
        : (cur + map[e.key] + ids.length) % ids.length;
      select(ids[next], true);
    });

    applyRoles();
    panels.forEach(initPanel);
  }

  function initPanel(panel) {
    var state = { mode: 'one', supply: '1', freq: '30' };
    var base = parseInt(panel.dataset.price, 10) || 0;              // cents, one bottle
    var subOff = parseFloat(panel.dataset.subDiscount || '0') / 100;
    var plans = [];
    try { plans = JSON.parse(panel.dataset.plans || '[]'); } catch (e) { plans = []; }
    var hasPlan = plans.length > 0;
    var previewOnly = panel.dataset.subPreview === 'true' && !hasPlan;
    var unitWord = panel.dataset.unitWord || 'bottle';

    var tiers = [];
    try { tiers = JSON.parse(panel.dataset.tiers || '[]'); } catch (e) { tiers = []; }

    var supplyWrap = $('.nv-supply', panel);
    var priceEl = $('.nv-price', panel);
    var noteEl = $('.nv-qa__note span', panel);
    var labEl = $('.nv-opt__lab .nv-js-optlab', panel);
    var addBtn = $('.nv-js-add', panel);
    var flagEl = $('.nv-qa__flag', panel);
    var mediaEl = $('.nv-qa__media', panel);

    /* A subscription delivers a full supply each time, so the interval the
       shopper picks is also how many units ship in that delivery. The options
       come from the store's own selling plans, so the interval on the button
       is always the interval the plan will actually bill on. */
    var plural = unitWord + 's';

    function freqFrom(months, id) {
      return {
        k: String(months * 30), qty: months, planId: id || null,
        label: (months * 30) + ' Days',
        sub: months === 1
          ? '1 ' + unitWord + ' each month'
          : months + ' ' + plural + ' every ' + months + ' months'
      };
    }

    var freqs = plans.length
      ? plans.map(function (pl) { return freqFrom(planMonths(pl.t), pl.id); })
          .sort(function (a, b) { return a.qty - b.qty; })
      : [freqFrom(1), freqFrom(2), freqFrom(3)];

    function currentFreq() {
      for (var i = 0; i < freqs.length; i++) if (freqs[i].k === String(state.freq)) return freqs[i];
      return freqs[0];
    }
    if (!freqs.some(function (f) { return f.k === state.freq; })) state.freq = freqs[0].k;

    function currentTier() {
      for (var i = 0; i < tiers.length; i++) if (String(tiers[i].qty) === String(state.supply)) return tiers[i];
      return tiers[0] || { qty: 1, off: 0, label: '30 Day', sub: '1 ' + unitWord };
    }

    function compute() {
      if (state.mode === 'sub') {
        var f = currentFreq();
        var sfull = base * f.qty;
        var snow = Math.round(sfull * (1 - subOff));
        return { now: snow, was: subOff > 0 ? sfull : null,
                 per: Math.round(snow / f.qty), qty: f.qty };
      }
      var t = currentTier();
      var full = base * t.qty;
      var now = Math.round(full * (1 - (t.off || 0) / 100));
      return { now: now, was: (t.off || 0) > 0 ? full : null, per: Math.round(now / t.qty), qty: t.qty };
    }

    function renderOptions() {
      var isSub = state.mode === 'sub';
      var opts = isSub ? freqs : tiers;
      var cur = isSub ? state.freq : state.supply;
      supplyWrap.innerHTML = opts.map(function (o) {
        var val = isSub ? o.k : o.qty;
        var tag = !isSub && o.tag ? '<span class="nv-supply__tag">' + o.tag + '</span>' : '';
        return '<button type="button" class="nv-supply__b nv-js-opt" data-v="' + val + '"' +
          ' aria-pressed="' + (String(val) === String(cur) ? 'true' : 'false') + '">' + tag +
          '<span class="nv-supply__t">' + o.label + '</span>' +
          '<span class="nv-supply__s">' + o.sub + '</span></button>';
      }).join('');
      if (labEl) labEl.textContent = isSub ? 'Deliver every' : 'Choose your supply';
      $$('.nv-js-mode', panel).forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.v === state.mode ? 'true' : 'false');
      });
      if (flagEl) flagEl.hidden = !(isSub && previewOnly);
    }

    function renderPrice() {
      var p = compute();
      var isSub = state.mode === 'sub';
      priceEl.innerHTML =
        '<span class="nv-price__now">' + money(p.now) + '</span>' +
        (p.was ? '<span class="nv-price__was">' + money(p.was) + '</span>' : '') +
        '<span class="nv-price__per">' + money(p.per) + ' per ' + unitWord +
        (isSub ? ' &middot; billed each delivery' : '') + '</span>';
      if (noteEl) {
        noteEl.textContent = isSub
          ? 'Pause, skip or cancel any time from your account'
          : (panel.dataset.shipNote || '');
      }
    }

    function renderPack() {
      /* One bottle drawn per unit going into the cart, on both modes: a
         60 or 90 day supply shows two or three, whether it is bought once
         or delivered on a plan. */
      if (mediaEl) mediaEl.dataset.qty = String(compute().qty || 1);
    }

    function sync() { renderOptions(); renderPrice(); renderPack(); }

    panel.addEventListener('click', function (e) {
      var m = e.target.closest('.nv-js-mode');
      if (m) { state.mode = m.dataset.v; sync(); return; }
      var o = e.target.closest('.nv-js-opt');
      if (o) {
        if (state.mode === 'sub') state.freq = o.dataset.v; else state.supply = o.dataset.v;
        sync();
        return;
      }
      var a = e.target.closest('.nv-js-add');
      if (a) {
        e.preventDefault();
        var vid = panel.dataset.variant;
        if (!vid) { toast('This product has no purchasable variant yet'); return; }
        var p = compute();
        var item = { id: Number(vid), quantity: p.qty };
        var f = currentFreq();
        if (state.mode === 'sub' && f.planId) item.selling_plan = Number(f.planId);
        addToCart([item], panel.dataset.title || 'Item', a);
      }
    });

    sync();
  }

  /* ---------------- Stack add-to-cart ---------------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.nv-js-add-stack');
    if (!s) return;
    e.preventDefault();
    var ids = (s.dataset.variants || '').split(',').filter(Boolean);
    if (!ids.length) { toast('This stack has no products selected yet'); return; }
    addToCart(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), s.dataset.label || 'Stack', s);
  });

  /* ---------------- FAQ ---------------- */
  function initFaq(root) {
    $$('.nv-faq__q', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        $$('.nv-faq__q', root).forEach(function (o) {
          if (o !== btn && o.getAttribute('aria-expanded') === 'true') {
            o.setAttribute('aria-expanded', 'false');
            var op = document.getElementById(o.getAttribute('aria-controls'));
            if (op) op.style.height = '0px';
          }
        });
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
      });
    });
  }

  /* ---------------- Announcement-free niceties ---------------- */
  function initReveal() {
    var els = $$('.nv-rv:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- UGC tiles ----------------
     Autoplay, muted, looping. Three rules hold this together:
     browsers only grant autoplay while a video is muted, so unmuting is the
     one thing that must be user initiated; only one tile may carry sound at a
     time; and playback is tied to visibility so three files are not decoding
     while the visitor reads the FAQ. ---------------------------------------- */
  function initUgc() {
    var tiles = $$('.nv-ugc__c').filter(function (t) { return t.querySelector('video'); });
    if (!tiles.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function paint(tile) {
      var v = tile.querySelector('video');
      var m = tile.querySelector('[data-nv-mute]');
      var p = tile.querySelector('[data-nv-pause]');
      tile.classList.toggle('is-paused', v.paused);
      if (m) {
        m.dataset.muted = v.muted ? 'true' : 'false';
        m.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
      }
      if (p) p.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    }

    function muteAllBut(keep) {
      tiles.forEach(function (t) {
        var v = t.querySelector('video');
        if (v !== keep && !v.muted) { v.muted = true; paint(t); }
      });
    }

    tiles.forEach(function (tile) {
      if (tile.dataset.nvBound) return;
      tile.dataset.nvBound = '1';

      var v = tile.querySelector('video');
      /* Set it on the property as well as the attribute: Safari has shipped
         builds where the attribute alone is not enough to earn autoplay. */
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');

      var mute = tile.querySelector('[data-nv-mute]');
      var pause = tile.querySelector('[data-nv-pause]');
      var wanted = !reduce;   /* what the visitor last asked for */

      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }

      if (mute) {
        mute.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (v.muted) {
            muteAllBut(v);
            v.muted = false;
            /* Unmuting is a deliberate act, so start it if it was paused. */
            wanted = true;
            v.play().catch(function () {});
          } else {
            v.muted = true;
          }
          paint(tile);
        });
      }

      if (pause) {
        pause.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (v.paused) { wanted = true; v.play().catch(function () {}); }
          else { wanted = false; v.pause(); }
          paint(tile);
        });
      }

      ['play', 'pause', 'volumechange'].forEach(function (n) {
        v.addEventListener(n, function () { paint(tile); });
      });

      /* Pause offscreen, resume on return, but never override a deliberate
         pause and never re-trigger sound the visitor did not ask for. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              if (wanted && v.paused) v.play().catch(function () {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: 0.35 }).observe(tile);
      }

      paint(tile);
    });
  }

  function initCapture() {
    $$('.nv-cap__form').forEach(function (f) {
      if (f.dataset.nvBound) return;
      f.dataset.nvBound = '1';
      f.addEventListener('submit', function (e) {
        var input = f.querySelector('input[type="email"]');
        if (input && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(input.value.trim())) {
          e.preventDefault(); toast('Please enter a valid email address');
        }
      });
    });
  }

  function boot() {
    $$('.nv-js-tabs').forEach(function (r) { if (!r.dataset.nvBound) { r.dataset.nvBound = '1'; initTabs(r); } });
    $$('.nv-js-faq').forEach(function (r) { if (!r.dataset.nvBound) { r.dataset.nvBound = '1'; initFaq(r); } });
    initUgc(); initCapture(); initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-bind after a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function () {
    $$('.nv-js-tabs,.nv-js-faq').forEach(function (r) { delete r.dataset.nvBound; });
    boot();
  });
})();
